/**
 * Icon Component - Controller
 * ===========================
 */

import type { ISCEService, IOnChangesObject } from 'angular';
import { getIcon, IconVariant } from '../../icons';
import { SIZE_CLASSES, VALID_SIZES, DEFAULTS, IconSize } from './constants';

export interface IconBindings {
  name?: string;
  variant?: IconVariant;
  size?: string;
  ariaLabel?: string;
}

export class IconController implements IconBindings {
  static $inject = ['$sce'];

  private $sce: ISCEService | null;

  name?: string;
  variant?: IconVariant;
  size?: string;
  ariaLabel?: string;

  trustedSvg: unknown = null;
  sizeClasses: string = SIZE_CLASSES[DEFAULTS.size];

  constructor($sce: ISCEService) {
    this.$sce = $sce;
  }

  $onInit(): void {
    this._resolve();
  }

  // name/variant/size pueden cambiar en runtime (ng-repeat, toggles, etc.) —
  // se re-resuelve el SVG y las clases de tamaño en cada cambio.
  $onChanges(changes: IOnChangesObject): void {
    if (changes.name || changes.variant || changes.size) {
      this._resolve();
    }
  }

  $onDestroy(): void {
    this.$sce = null;
  }

  private _resolveSize(): string {
    if (this.size == null || this.size === '') {
      return SIZE_CLASSES[DEFAULTS.size];
    }
    const parsed = Number(this.size) as IconSize;
    if (!VALID_SIZES.includes(parsed)) {
      console.warn(`[ec-icon] tamaño "${this.size}" inválido, usando ${DEFAULTS.size}.`);
      return SIZE_CLASSES[DEFAULTS.size];
    }
    return SIZE_CLASSES[parsed];
  }

  private _resolve(): void {
    this.sizeClasses = this._resolveSize();

    const variant: IconVariant = this.variant === 'solid' ? 'solid' : 'linear';
    const svg = this.name ? getIcon(this.name, variant) : null;
    this.trustedSvg = svg && this.$sce ? this.$sce.trustAsHtml(svg) : null;
  }
}

export default IconController;
